import React from 'react';
import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const PageBanner = ({ title, breadcrumb, backgroundImage }) => {
  return (
    <div
      className="relative h-64 md:h-80 bg-cover bg-center flex items-center justify-center"
      style={{ backgroundImage: `url(${backgroundImage})`,backgroundSize: 'cover', backgroundPosition: 'center' ,backgroundRepeat: 'no-repeat' }}
    >
      <div className="absolute inset-0 bg-[#2584C6] opacity-90"></div>
      <div className="relative text-center text-white px-4" data-aos="fade-down">
        <h1 className="text-3xl md:text-5xl font-bold mb-4">{title}</h1>
        <Link to="/" className="flex justify-center items-center gap-1 text-sm md:text-base">
          <Home size={16} className="text-white/80" />
          <span className="text-white/80">Home</span> / <span className="font-semibold">{breadcrumb}</span>
        </Link>
      </div>
    </div>
  );
};

export default PageBanner;
